// ============================================
// TECH MYTH BUSTERS  - PRODUCTS DATA
// ============================================
// To add, edit, or remove a product, just modify the object below.
// The key (e.g. "battery-1") is the id used by myths.js in relatedProductId.
//
// Required fields for each product:
//   name   - collection display name
//   image  - full image URL (use your Shopify CDN URL here)
//   pitch  - one-line selling description shown on the card
//   url    - collection page URL on tpstech.in (opens in new tab)
//
// HOW TO REPLACE PLACEHOLDER IMAGES:
//   Change the "image" value to your real product image URL.
//   Shopify CDN images look like: https://cdn.shopify.com/s/files/...
// ============================================

window.PRODUCTS = {
  "battery-1": {
    name: "Laptop Batteries",
    image: "https://www.tpstech.in/cdn/shop/files/hp-bp02xl-15-au-series.jpg?v=1733124814&width=600",
    pitch: "Genuine OEM battery  - 6–8 hours backup, 1-year warranty",
    url: "https://www.tpstech.in/collections/laptop-battery"
  },
  "ram-1": {
    name: "RAM",
    image: "https://www.tpstech.in/cdn/shop/products/XPG_GAMMIX_D30_DDR4_RED_U-DIMM_RAM_from_The_Peripheral_Store_TPS_Tech_Free_Delivery_5_166d152d-db9d-4e8a-be3e-86f072abe84e.jpg?v=1571609182&width=600",
    pitch: "Speed up your system with blazing-fast DDR5 memory",
    url: "https://www.tpstech.in/collections/desktop-memory"
  },
  "monitor-1": {
    name: "Monitors",
    image: "https://www.tpstech.in/cdn/shop/files/1_DELL_U2723QE_UltraSharp_27_2160p_4K.webp?v=1760845093&width=600",
    pitch: "Crisp IPS panel with 75Hz refresh rate for smooth gaming",
    url: "https://www.tpstech.in/collections/4k-monitors"
  },
  "ssd-1": {
    name: "SSD",
    image: "https://www.tpstech.in/cdn/shop/products/samsung-internal-ssd_990-pro-1tb_from_tpstech.in-main.jpg?v=1675759341&width=600",
    pitch: "10x faster than HDDs  - boot in seconds",
    url: "https://www.tpstech.in/collections/nvme-ssds"
  },
  "cooling-1": {
    name: "Cooling",
    image: "https://www.tpstech.in/cdn/shop/products/01_13a3d6f7-5af2-43e5-b546-3340f504f233.jpg?v=1594015175&width=600",
    pitch: "Keep your CPU cool under load  - whisper quiet",
    url: "https://www.tpstech.in/collections/cooling"
  },
  "gpu-1": {
    name: "Graphic Cards",
    image: "https://www.tpstech.in/cdn/shop/files/w800_31.jpg?v=1742640915&width=600",
    pitch: "Smooth 1440p gaming at high settings",
    url: "https://www.tpstech.in/collections/graphic-cards"
  },
  "psu-1": {
    name: "Power Supply",
    image: "https://www.tpstech.in/cdn/shop/files/Cooler_Master_V_Platinum_1600_V2_ATX_3.1_1600W_Fully_Modular_PSU-tpstech.in.webp?v=1773042415&width=600",
    pitch: "Reliable power for your build  - 5-year warranty",
    url: "https://www.tpstech.in/collections/power-supply"
  }
};
